import { EventEmitter, Injectable, Input, Output } from '@angular/core';
import { LoaderService } from './loader.service';
import { ToastMessageService } from './toast-message.service';
import { MessageService } from './message.service';
import { Observable } from 'rxjs';
import { HttpEventType, HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileValidationService {
  @Input() isImageExits: boolean = false;
  @Output() imageExitsChange = new EventEmitter<boolean>();
  @Output() fileuploaded = new EventEmitter<any>();

  @Input() placeholder = 'Only .txt, .docx, .pdf, .pptx, spreadsheets(.csv, .xls, .xlsx) and images (.jpg, .jpeg, .png) files are allowed (max Size 16 MB)';
  @Input() inputAccept = '.pdf,.PDF,.txt,.TXT,.pptx,.PPTX,.pptx,.docx,.DOCX,.xlsx,.XLXS,.csv,.CSV,.xls,.XLS,.jpeg,.png,.jpg'



  containsImages: boolean = false;

  selectedFiles?: FileList;
  currentFile?: File;


  // @Output() isImageExits: EventEmitter<boolean> = new EventEmitter<boolean>();
  fileInfos?: Observable<any>;

  @Input() maxFileSize: any = 50;
  constructor(
    private toastMessage: ToastMessageService,
  ) { }


  byodFileValidation(uploadFile: any): any {
    let supported_multi_files = ['.pdf', '.PDF', '.txt', '.TXT', '.pptx', '.PPTX', '.pptx', '.docx', '.DOCX'];
      if(uploadFile.length > 1){
        for (const file of uploadFile) {
          // checking file not support in multiple file upload
          if (!supported_multi_files.includes(this.checkFileExtension(file))) {
            this.toastMessage.showError(" Please don't upload image files  if you are uploading multiple files");
            return false;
          }
        }
      }
  }

  translateFileValidation(uploadFile: any): any {
    let supported_multi_files = ['.jpg', '.jpeg', '.png', '.tiff'];
    if(uploadFile.length > 1){
      for (const file of uploadFile) {
        // checking file not support in multiple file upload
        if (!supported_multi_files.includes(this.checkFileExtension(file))) {
          this.toastMessage.showError("Only image files are allowed if you are uploading multiple files");
          return false;
        }
      }
    }
  }

  transcribeFileValidation(uploadFile: any): any {
    console.log(uploadFile);
    if(uploadFile.length > 1){
      this.toastMessage.showError("Please do not upload multiple files");
      uploadFile = [];
      return false;
    }
  }

  clearFileInput(id: string) {
    let input1 = document.getElementById(id) as HTMLInputElement;
    input1.value = '';
    console.log(this.selectedFiles);
    this.selectedFiles = undefined;
  }


  checkFileExtension(file: any) {
    // checking file type
    let patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
    let fileExtension = (file.name).match(patternFileExtension);
    return '.' + fileExtension[1];
  }

  checkFileSupported(file: any) {
    return this.inputAccept.split(',').includes(this.checkFileExtension(file));
  }

}
